module.exports = __webpack_public_path__ + "img/fail.1ec0f303.png";